import { render } from "./table-report-progress.vue?vue&type=template&id=a2abf546"
import script from "./table-report-progress.vue?vue&type=script&lang=js"
export * from "./table-report-progress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__